import * as uuid from 'uuid';
import { type FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';

import ModalWindow from '@editor2/components/ModalWindow';
import { addChapter } from '@editor2/reducers/editor/editorSlice';
import { type RootState } from '@editor2/reducers/root';
import { addChapterBlock } from './styles';

interface Props {
	chapterId?: string;
	isShown: boolean;
	courseId: number;
	onHide: () => void;
}

const AddChapterModal: FC<Props> = (props) => {
	const { chapterId, isShown, courseId, onHide } = props;

	const dispatch = useDispatch();
	const { chapter_types } = useSelector((state: RootState) => state.courses[courseId].config);
	const chapterTypesKeys = Object.keys(chapter_types);

	const [chapterNumber, setChapterNumber] = useState('');
	const [chapterName, setChapterName] = useState('');
	const [chapterType, setChapterType] = useState('normal');

	const addChapterSubmit = () => {
		const enablePageGroups = chapter_types[chapterType].page_groups_enabled;
		const chapterEntity = {
			name: chapterName,
			family_id: uuid.v4(),
			chapter_type: chapterType,
			chapter_number: chapterNumber,
			page_groups_enabled: enablePageGroups,
			type: 'NG::Traditional::Chapter',
			...(enablePageGroups ? { page_groups: [] } : { pages: [] })
		};
		dispatch(addChapter({ chapterId, chapterEntity, courseId }));

		onHide();
	};

	const title = <div>Add new chapter</div>;

	const footer = (
		<Button variant="success" size="sm" disabled={!chapterName} onClick={addChapterSubmit}>
			Add
		</Button>
	);

	return (
		<ModalWindow isShown={isShown} onHide={onHide} title={title} footer={footer}>
			<div className={addChapterBlock}>
				<Form.Group>
					<Form.Label>Chapter type</Form.Label>
					<Form.Control
						as="select"
						defaultValue={'normal'}
						onChange={(e) => setChapterType(e.target.value)}>
						{chapterTypesKeys.map(
							(type) =>
								chapter_types[type].enabled && (
									<option key={type} value={type}>
										{chapter_types[type].human_name}
									</option>
								)
						)}
					</Form.Control>
				</Form.Group>

				<Form.Group>
					<Form.Label>Number</Form.Label>
					<Form.Control
						placeholder="Enter chapter number"
						onChange={(e) => setChapterNumber(e.target.value)}
					/>
				</Form.Group>
			</div>
			<Form.Group>
				<Form.Label>Chapter name</Form.Label>
				<Form.Control
					placeholder="Enter chapter name"
					onChange={(e) => setChapterName(e.target.value)}
				/>
			</Form.Group>
		</ModalWindow>
	);
};

export default AddChapterModal;
